import { TAGS } from "../constants";
import { ConversationThread } from "../types";
import { api } from "./api";

export const conversationThreadsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getConversationThreads: builder.query<
      ConversationThread[],
      {
        agent?: string;
        profile_id?: string;
      }
    >({
      query: (params) => ({
        method: "GET",
        url: `/api/conversation-threads`,
        params,
      }),
      providesTags: [TAGS.CONVERSATION_THREADS],
    }),
  }),
});

export const { useGetConversationThreadsQuery } = conversationThreadsApi;
